var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "89px",
    height: "72px",
    viewBox: "0 0 89 72",
    style: {
      enableBackground: "new 0 0 89 72"
    },
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Acura") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer_Large_1400px",
    transform: "translate(-176.000000, -1471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer_links",
    transform: "translate(0.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blue-footer",
    transform: "translate(0.000000, 734.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(31.974724, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Acura-Logo",
    transform: "translate(144.343717, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.8,47h3.5l7.8,13h-3.7l-5.9-9.9l-3.1,5.2h5l1.5,2.5H5.1L3.7,60H0L7.8,47z M77.2,47h3.5l7.8,13h-3.7 l-5.9-9.9l-3.1,5.2h5l1.5,2.5h-7.9L73.1,60h-3.7L77.2,47z M18.9,53.5v1.7c0.1,3.4,2,4.8,4.9,4.8h9.8v-2.7h-9.7 c-1.6,0-1.8-1.1-1.8-2.2v-3.3c0-1,0.2-2.2,1.8-2.1h9.7V47h-9.8c-3-0.1-4.9,1.4-4.9,4.8V53.5L18.9,53.5z M56,60h-3.2V47h11.8 c4.1,0,5.2,5.5,2.3,7.4c0.9,0.6,1.4,1.5,1.5,2.6c0.1,0.5,0.1,3,0.1,3h-3.1l-0.1-2.7c0-0.5-0.2-1-0.6-1.4 c-0.4-0.4-0.9-0.6-1.4-0.5h-6l-0.6-2.8h7.1c0.6,0.1,1.1-0.2,1.4-0.6s0.3-1.1,0-1.6s-0.9-0.7-1.4-0.6H56V60L56,60z M43.1,60 h2.8c3.4-0.1,4.8-2,4.8-5v-8h-3.1v8.7c0,1.6-1.1,1.8-2.2,1.8h-4.5c-1,0-2.2-0.2-2.1-1.8V47h-3.2v8c-0.1,3,1.4,4.9,4.8,4.9 H43.1L43.1,60z M57.9,25.2c-0.3-4.8-1.9-8.4-4.2-10.3c-2.4-2.1-7-2.9-10.5-2.9c-3.5,0-8.1,0.8-10.5,2.9 c-2.3,1.9-3.9,5.5-4.2,10.3c-0.2,4.5,0.8,9.5,3.3,12.3c2.5,2.8,7.5,3.6,11.3,3.6h0c3.9,0,8.8-0.9,11.3-3.6 C57.1,34.7,58.1,29.8,57.9,25.2L57.9,25.2z M42.4,13.2c0.5,0,0.6,0,0.8,0c0.2,0,0.3,0,0.8,0l0,10.6h-1.7L42.4,13.2z  M30.5,29.7c-0.2-1.8-0.7-8.5,1.9-12.3c1.1-1.6,2.7-2.7,4.4-3.3c1.7-0.5,3.4-0.8,5.1-0.9c-1.1,2.7-3.3,8.4-3.8,9.7 c-0.7,1.7-1.2,3.4-1.4,5.2c-0.3,2.3-0.8,8-0.9,10.5C32.8,37.2,30.9,34.4,30.5,29.7L30.5,29.7z M50.2,38.8 c-4.5,1.5-9.5,1.5-14,0l0,0c1.8-4.6,3.8-9,6-13.4h1.9C46.5,29.8,48.5,34.3,50.2,38.8L50.2,38.8L50.2,38.8z M55.9,29.7 c-0.4,4.7-2.3,7.5-5.4,9c-0.1-2.5-0.6-8.2-0.9-10.5c-0.3-1.8-0.8-3.6-1.4-5.2c-0.4-1.3-2.7-7-3.7-9.7c1.7,0.1,3.4,0.3,5.1,0.9 c1.8,0.6,3.4,1.8,4.4,3.3C56.6,21.2,56.1,27.9,55.9,29.7L55.9,29.7z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcura);
export default __webpack_public_path__ + "static/media/acura.137deaa5a9b14a03cb1eca460bcf500f.svg";
export { ForwardRef as ReactComponent };